export default class Helpers {
    static findCarImageModule(team) {
        const formattedTeamName = this.formatTextForAssetNames(team);
        try {
            return require(`../assets/jerseys/scrum-cap.png`);
        } catch (e) {
            return require(`../assets/jerseys/default-scrum-cap.png`);
        }
    }

    static findJerseyImageModule(name) {
        const hasName = name && name !== 'no-player';
        if (!hasName) return require(`../assets/scrumCaps/btn-add-player.png`);

        const normalizedName = this.normalizeTeamName(name);
        const candidates = this.getJerseyNameCandidates(normalizedName);

        for (const candidate of candidates) {
            try {
                return require(`../assets/jerseys/${candidate}-kit.webp`);
            } catch (e) {
                // Continue through candidates until a matching asset is found.
            }
        }

        // If we don't have a specific kit, show a generic jersey instead of add-player icon.
        return require(`../assets/jerseys/default-kit.webp`);
    }

    static findLeagueImageModule(league) {
        const name = typeof league === "object" ? league.leagueName : league
        const reformattedLeagueName = this.formatTextForAssetNames(name);
        try {
            return require(`../assets/leagueLogos/${reformattedLeagueName}-logo-colour.png`)
        } catch (e) {
            return require(`../assets/default-badge.webp`)
        }
    }

    static findTeamImageModule(teamName) {
        const reformattedTeamName = this.formatTextForAssetNames(teamName);
        // Teams that share an existing badge under a different name.
        const badgeAliases = {
            'free-state-cheetahs': 'toyota-cheetahs',
            'sigma-lions': 'lions',
        };
        const badgeName = badgeAliases[reformattedTeamName] || reformattedTeamName;
        try {
            return require(`../assets/teamBadges/${badgeName}-logo-icon.webp`)
        } catch (e) {
            return require(`../assets/default-badge.webp`)
        }
    }

    static formatTextForAssetNames(text) {
        const lowerCase = text.toLowerCase();
        return lowerCase.replaceAll(' ', '-');
    }

    static normalizeTeamName(text) {
        return text
            .toLowerCase()
            .replaceAll('&', 'and')
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    static getJerseyNameCandidates(normalizedName) {
        const aliases = {
            'stormers': 'dhl-stormers',
            'bulls': 'vodacom-bulls',
            'lions': 'emirates-lions',
            'sharks': 'hollywoodbets-sharks',
            'benetton rugby': 'benetton',
            'cardiff rugby': 'cardiff',
            'connacht rugby': 'connacht',
            'dragons rfc': 'dragons',
            'edinburgh rugby': 'edinburgh',
            'leinster rugby': 'leinster',
            'munster rugby': 'munster',
            'ulster rugby': 'ulster',
        };

        const canonical = aliases[normalizedName] || normalizedName;
        const withDashes = canonical.replaceAll(' ', '-');

        const withoutSuffixes = canonical
            .replace(/\b(rugby|rfc)\b/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .replaceAll(' ', '-');

        return [...new Set([
            withDashes,
            withoutSuffixes,
            `${withDashes}-rugby`,
            `${withoutSuffixes}-rugby`,
        ].filter(Boolean))];
    }
}
